// extracted by mini-css-extract-plugin
export default {"overlay":"Custom_overlay__yM3bs"};